import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, fmtDateTime } from "@/lib/api";

export default function Privacy() {
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get("/associazione").then((r) => setD(r.data));
  }, []);
  if (!d) return null;
  const sede = [d.indirizzo, [d.cap, d.citta].filter(Boolean).join(" ")].filter(Boolean).join(", ");
  return (
    <div className="min-h-screen bg-[#F4F6F9] px-4 py-10">
      <div className="max-w-3xl mx-auto bg-white border rounded-2xl overflow-hidden">
        <div className="tricolore h-1.5" />
        <div className="p-8 sm:p-12">
          <Link to="/" className="flex items-center gap-3 mb-8" data-testid="privacy-home-link">
            <img src="/logo-9er.png" alt="Logo" className="h-12 w-12" />
            <span className="font-heading uppercase text-lg leading-tight">{d.nome}</span>
          </Link>
          <h1 className="font-heading text-4xl sm:text-5xl font-bold uppercase text-[#0B192C] mb-2">Privacy policy</h1>
          {d.privacy_updated_at && <p className="text-xs text-muted-foreground mb-6">Aggiornata il {fmtDateTime(d.privacy_updated_at)}</p>}
          <div className="whitespace-pre-line text-slate-700 leading-relaxed" data-testid="privacy-text">
            {d.privacy_policy || "L'informativa privacy non è ancora stata pubblicata."}
          </div>
          <div className="mt-10 pt-6 border-t text-sm text-slate-600 space-y-1" data-testid="privacy-titolare">
            <div className="font-semibold text-[#0B192C]">Titolare del trattamento: {d.nome}</div>
            {sede && <div>{sede}</div>}
            {d.codice_fiscale && <div>C.F. {d.codice_fiscale}</div>}
            {d.email && <div>Email: {d.email}</div>}
            {d.telefono && <div>Tel: {d.telefono}</div>}
          </div>
        </div>
      </div>
    </div>
  );
}
